var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow-down"),React.createElement("g",{"id":"Desktop","key":1},React.createElement("g",{"id":"Retail"},React.createElement("polygon",{"id":"Fill-1-Copy-2","points":"7 4.29 6.44 3.7 3.76 6.54 3.8 0.02 3.08 0 3.08 6.38 0.56 3.7 0 4.29 3.48 8 3.5 7.98 4.04 7.41 7 4.29","style":{"fillRule":"evenodd"}})))]);
}

ArrowDown.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 7 8"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
